import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { stack } from '../data/content';
function TechStack() {
  return (
    <section className="pad" id="stack" style={{ background: 'var(--bg-2)' }}>
      <div className="wrap">
        <div className="section-head">
          <span className="eyebrow">Tech Stack</span>
          <h2 className="h-section">The tools I build with</h2>
          <p>Three layers, one developer. From the button a user clicks to the row that gets saved — I own the whole stack.</p>
        </div>
        <div className="stack-grid">
          {stack.map((s, i) => {
            const Icon = FiIcons[s.icon];
            return (
              <motion.div className="stack-card" key={s.role} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}>
                <h3><SafeIcon icon={Icon} /> {s.role}</h3>
                <div className="role">{s.role} layer</div>
                <ul>{s.items.map((it) => <li key={it}>{it}</li>)}</ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
export default TechStack;
